export const styles = {
  modal: {
    '& .MuiDialogActions-root': {
      justifyContent: 'center',
      height: '48px',
      padding: 0,
      '& button': {
        margin: '0 12px',
      },
    },

    '& .MuiDialog-paper': {
      width: '1100px',
      maxWidth: '1100px',
      borderRadius: '12px',
      overflow: 'hidden',
      padding: '0',
      backgroundColor: '#fff',
    },
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    padding: '15px',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    padding: '30px',
    borderBottom: '1px solid #EDEFF7',
  },
  headerInfoWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  headerTextWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1px',
  },
  name: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: '24px',
    lineHeight: '136%',
    color: '#23252F',
  },
  size: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '150%',
    color: '#23252F',
  },
  close: {
    position: 'absolute',
    right: '46px',
    padding: '10px',
    cursor: 'pointer',
  },
  dialogPaper: {
    maxHeight: '95vh',
    height: '95vh',
    borderRadius: '12px',
  },
  dialogContent: {
    height: '100%',
    overflow: 'hidden',
    padding: 0,
    position: 'relative',
  },
  modalCloseButton: {
    position: 'absolute',
    top: '16px',
    right: '16px',
    zIndex: 1000,
    padding: '10px',
    cursor: 'pointer',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 1)',
    },
  },
  dialogScrollableContainer: {
    flexGrow: 1,
    overflowY: 'auto',
    p: 2,
    '&::-webkit-scrollbar': {
      border: 'none',
      width: '11px',
      height: '11px',
      padding: '5px 0',
    },

    '&::-webkit-scrollbar-track': {
      backgroundColor: '#fff',
      border: 'none',
      height: '10px',
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#D4D6E0',
      width: '2px',
      borderRadius: '6px',
      cursor: 'pointer',
    },
  },
};
